import { render } from "./ModalDashboardComponet.vue?vue&type=template&id=949dff8a&scoped=true"
import script from "./ModalDashboardComponet.vue?vue&type=script&lang=js"
export * from "./ModalDashboardComponet.vue?vue&type=script&lang=js"

import "./ModalDashboardComponet.vue?vue&type=style&index=0&id=949dff8a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949dff8a"]])

export default __exports__